import { AppQbemApiView } from "./AppQbemApi.View";

export function AppQbemApi() {
  return <AppQbemApiView />;
}
